import { StateTypes } from "./saveState";

export const loadState = <StateKey extends keyof StateTypes>(
  key: StateKey
): StateTypes[StateKey] | undefined => {
  try {
    const serialState = sessionStorage.getItem(`appState.${key}`);
    if (serialState === null) {
      return undefined;
    }
    return JSON.parse(serialState);
  } catch (err) {
    return undefined;
  }
};
